import React from 'react';
import { arrayOf, bool, string } from 'prop-types';
import { connect } from 'react-redux';
import { getMessage } from '@tcc/i18n';
import styles from './css/WeatherForecastContainer.css';
import CurrentConditionsContainer from './CurrentConditionsContainer';
import HourlyForecastContainer from './HourlyForecastContainer';
import DailyForecastContainer from './DailyForecastContainer';

function WeatherForecastContainer({
  fieldFeatures = [],
  isMicrosoftWxFeatureAvailable,
}) {
  return (
    <div
      className={styles.weatherForecastContainer}
      data-test-id="weather-forecast-container"
    >
      <div className={styles.title}>{getMessage('forecast.title')}</div>

      {fieldFeatures.includes('CurrentConditions') ? (
        <CurrentConditionsContainer
          isMicrosoftWxFeatureAvailable={isMicrosoftWxFeatureAvailable}
        />
      ) : null}

      {fieldFeatures.includes('Forecast') ? (
        <HourlyForecastContainer
          isMicrosoftWxFeatureAvailable={isMicrosoftWxFeatureAvailable}
        />
      ) : null}

      {fieldFeatures.includes('Forecast') ? (
        <DailyForecastContainer
          isMicrosoftWxFeatureAvailable={isMicrosoftWxFeatureAvailable}
        />
      ) : null}
    </div>
  );
}

WeatherForecastContainer.propTypes = {
  fieldFeatures: arrayOf(string).isRequired,
  isMicrosoftWxFeatureAvailable: bool,
};

function mapStateToProps(state) {
  return {
    fieldFeatures: state.field.fieldFeatures,
  };
}

export default connect(mapStateToProps)(WeatherForecastContainer);
